<template>
  <div class="double11-wrap">
    <app-header />
    <div class="auto1200">


      <div class="anchor-box">
        <div class="top-box">
          <div class="time-text">
            活动时间：10月15日-11月11日
          </div>
          <div class="panel-box tag-box">
            <span class="left-fixtag">
              双十一特惠抢
            </span>
            <div class="line-box">
              <span>
                <em class="red-f">限时</em>买一得二：
              </span>
              <ul>
                <li v-for="(item,index) in 2" :key="index" @click="tagIndex=index" :class="{cur:tagIndex==index}">
                  <span>{{tag[index]}}</span>
                </li>
              </ul>
            </div>
            <div class="line-box">
              <span>
                <em class="red-f">七折</em>特惠专区：
              </span>
              <ul>
                <li v-for="(item,index) in 4" :key="index" :class="{cur:tagIndex==(index+2)}" @click="tagIndex=(index+2)">
                  <span>{{tag[index+2]}}</span>
                </li>
              </ul>
            </div>
          </div>

        </div>

        <div class="anchor-list">
          <div class="anch-ctn">
            <div class="clearfix panel-box pd-box" v-for="(item,index) in list" :key="index" :id="'anh'+index">
              <span class="left-fixtag">
                {{item.lefttag}}
              </span>
              <div class="img-box">
                <!-- <em class="status-box">{{item.status}}</em>
                <span class="title-box" v-html="item.title"></span>
                <span class="btm-coupon">{{item.coupon}}</span> -->
                <img :src="require('../../assets/images/activity/double11/3/'+item.img)"/>
                <div class="btm-fix">
                  双年卡、季卡、月卡均不参与此活动
                </div>
              </div>
              <div class="r-box">
                <div class="tle-box">
                  <span v-html="item.title"></span><span class="red-f" v-html="item.titleTip"></span>
                </div>
                <div class="tle-btm" v-html="item.desc"></div>
                <div class="price-box">
                  <span class="price-num">￥<em class="big-f">{{item.priceNum}}</em>/{{item.calc}}

                  <em class="old-price" v-if="item.oldPrice">{{item.oldPrice}}</em></span>
                  <span class="pay-btn" @click="goUrl(item.id,item.month)">立即购买</span>
                </div>
                <!-- <div class="price-box mt16" v-if="index==5">
                  <span class="price-num">￥<em class="big-f">16800</em>/年卡<em class="old-price" v-if="item.oldPrice">{{item.oldPrice}}</em></span>
                  <span class="pay-btn">立即购买</span>
                </div> -->
                <div class="btm-btmtip">
                  {{item.btnTip}}
                </div>
              </div>
              <p class="btm-tip" v-if="index==5">温馨提示：大智慧策略投资终端及老用户购买优选大师财富版不赠送大智慧财富版年卡，优选大师财富版半年卡不附赠大智慧财富版</p>
            </div>
            <div class="foot-text">
              活动须知：大智慧365、大智慧启航版、大智慧专业版、大智慧财富版、大智慧策略投资终端双年卡、季卡，月卡均不参与活动。大智慧策略投资终端及老用户购买优选大师财富版不赠送大智慧财富版年卡，优选大师财富版半年卡不附赠大智慧财富版，最终解释权归本公司所有
            </div>
            <div class="foot-tip">
              股市有风险，投资需谨慎
            </div>
          </div>



        </div>

      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  data() {
    return {
      tagIndex:0,
      tag:[
        '大智慧365','策略投资终端','大智慧启航版','大智慧专业版','大智慧财富版','优选大师'
      ],
      list:[
        {
          id:'116',
          month:'24',
          lefttag:'买一得二',
          img:'img1.jpg',
          title:'大智慧365·年卡限时疯抢',
          titleTip:'买一年<em class="big-f">得</em>两年!',
          desc:'包含年度Level-2全推行情、资金流向、特色指标战法。',
          priceNum:'998',
          calc:'2年',
          btnTip:'*赠送《曹老师直播大智慧软件入门课程》'
        },
        {
          id:'113',
          month:'24',
          lefttag:'买一得二',
          img:'img2.jpg',
          title:'大智慧策略投资终端·年卡',
          titleTip:'买一年<em class="big-f">得</em>两年!',
          desc:'专为专业投资者和专业机构所设计的高端金融信息服务产品，精选系统策略，创造投资新高度',
          priceNum:'38000',
          calc:'2年',
          btnTip:'*赠送《曹老师直播大智慧软件VIP课程》、题材王书籍、限量银条(限前48名)'
        },
        {
          id:'338',
          month:'12',
          lefttag:'限时优惠',
          img:'img3.jpg',
          title:'大智慧启航版·年卡',
          //titleTip:'',
          desc:'界面简洁，简单易学的炒股利器！极速行情，特色指标，四维战法助你轻松选股操作！软件轻量化，价格亲民化',
          priceNum:'418',
          calc:'年',
          oldPrice:'原价598',
          btnTip:''
        },
        {
          id:'73',
          month:'12',
          lefttag:'限时优惠',
          status:'年卡',
          img:'img4.jpg',
          title:'大智慧专业版·年卡',
          //titleTip:'',
          desc:'为专业投资型用户所研发的软件，提供全面的市场交易数据可按投资者思路对指标设计、公式选股、扩展数据进行深度个性化运用，建立个人专属的投资模型，决胜A股',
          priceNum:'1876',
          calc:'年',
          oldPrice:'原价2680',
          btnTip:''
        },
        {
          id:'126',
          month:'12',
          lefttag:'限时优惠',
          img:'img5.jpg',
          title:'大智慧财富版·年卡',
          //titleTip:'',
          desc:'囊括各类证券市场常用分析系统，从市场行情、深度资讯、宏观行业数据等全方位出发，打造多样化决策系统，满足不同投资者的需求',
          priceNum:'6860',
          oldPrice:'原价9800',
          calc:'年',
          btnTip:''
        },
        {
          id:'197',
          month:'6',
          lefttag:'限时优惠',
          img:'img6.jpg',
          title:'优选大师财富版',
          //titleTip:'',
          desc:'AI资金决策系统、个股特色诊断、优选500·赢在开盘·盘中黑马等AI算法生成的 <em class="y-f">8大信号池</em>',
          priceNum:'6860',
          oldPrice:'原价9800',
          calc:'半年',
          btnTip:''
        }
      ]
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted:function(){
    // window.addEventListener('scroll', function(){
    //   var scroll = document.documentElement.scrollTop || document.body.scrollTop
    //   var top = document.querySelector('.time-text').offsetTop +168
    //   if(scroll>=top){
    //     document.querySelector('.anchor-box').classList.add('fix')
    //   }else{
    //     document.querySelector('.anchor-box').classList.remove('fix')
    //   }
    // }, true)
  },
  watch: {
    tagIndex:function(){
      window.scrollTo(0,document.querySelector('#anh'+this.tagIndex).offsetTop+570);
      // window.scrollTo({
      //   left: 0,
      //   top: document.querySelector('#anh'+this.tagIndex).offsetTop +570, // 可以根据滚动情况增减数值
      //   behavior: "smooth"
      // });
    }
  },
  methods: {
    goUrl (key, month) {
      this.$router.push("/order/confirm/"+key+"/"+month);
    }
  },
  components: {
    AppHeader,
  }
}
</script>

<style lang="scss" scoped>
/deep/.double11-wrap{
  background: url(../../assets/images/activity/double11/3/bg1.jpg) no-repeat center 100px,
  url(../../assets/images/activity/double11/3/bg2.jpg) no-repeat center 770px #8c0000;
  .auto1200{
    width: 1200px;margin: 0 auto;


    .time-text{
      width:390px;
      height: 40px;
      border-radius: 40px;
      border: 1px solid #fff;
      font-size: 22px;
      line-height: 38px;
      text-align: center;
      color: #fff;
      margin:0 auto 30px;
      box-sizing: border-box;
    }
    .anchor-box{
      width: 819px;
      margin: 0 auto;
      position: relative;
      left: 1px;
      padding-bottom: 100px;
      .top-box{
        height: 770px;
        box-sizing: border-box;
        padding-top: 336px;
      }
      .top-box{
        padding-bottom: 240px;
        position: relative;
        .tag-box{
          position: absolute;
          top: 402px;
          left: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      &.fix{
        .top-box{
          .tag-box{
            position: fixed;
            top: 0;
            z-index: 5;
          }
        }
      }
    }
    .panel-box{
      border-radius: 0 0 40px 0;
      background-color: #fff;
      position: relative;
      width: 750px;
      box-sizing: border-box;
      margin: 0 auto;
      z-index: 2;
      .left-fixtag{
        font-size: 24px;
        color: #fff;
        line-height: 62px;
        padding: 0 12px;
        position: absolute;
        left: -10px;
        top: 0;
        border-radius: 0 0 30px 0;
        background: -webkit-linear-gradient(to right, #ff643a,#f71f1f);
        background: linear-gradient(to right, #ff643a,#f71f1f);
      }
      &.tag-box{
        padding-top: 98px;
        margin-bottom: 28px;
        height: 240px;
        box-sizing: border-box;

        .line-box{
          padding-left: 16px;padding-bottom: 20px;
          span{
            font-size: 20px;
            color: #222;
            .red-f{
              color: #d1252f;
            }
          }
          ul{
            margin: 0 -6px;
            text-align: center;
            display: inline-block;
            li{
              display: inline-block;
              line-height: 38px;
              padding: 0 10px;
              font-size: 20px;
              color: #fff;
              margin: 0 6px;
              position: relative;
              z-index: 1;
              border-radius: 40px;
              background: -webkit-linear-gradient(to right, #ff643a,#f71f1f);
              background: linear-gradient(to right, #ff643a,#f71f1f);
              span,a{
                cursor: pointer;
                color: #fff;
                position: relative;
                z-index: 1;
              }

              &.cur{
                span,a{
                  color: #d1252f;
                }
                &:before{
                  content: '';
                  position: absolute;

                  z-index: 0;
                  box-sizing: border-box;

                  background-color: #fff;
                  border-radius: 100px;
                   top: 2px;left: 2px;
                   right: 2px;
                   bottom: 2px;
                }
              }
            }
          }
        }

      }
    }
    .anchor-list{
      width: 100%;
      width: 919px;
      margin-left: -50px;
      //margin-top: -129px;
      padding-top: 2px;
      position: relative;
      padding-bottom:10px;
      &:before{
        background: -webkit-linear-gradient(to bottom,transparent 1%,#bf0000,#df0000,#ac0000);
        background: linear-gradient(to bottom,transparent 1%,#bf0000,#df0000,#ac0000);
        content: '';
        position: absolute;
        width: 819px;
        height: 100%;
        box-shadow: 0 0 0 0 rgba(255,255,0,0),
        12px 12px 20px 0  rgba(0,0,0,0.25),
        -12px 12px 20px 0  rgba(0,0,0,0.25),
        0px 0 0 0  rgba(0,0,0,0);
        top:0;
        left: 50%;
        transform: translateX(-50%);
      }
      .anch-ctn{
        width: 750px;
        margin: 0 auto;
        position: relative;
        z-index: 1;
        padding-bottom: 30px;
      }
      .pd-box{
        margin-bottom: 40px;
        padding: 82px 27px 45px;
        &:first-child{
          margin-top: -96px;
        }
        .left-fixtag{
          font-size: 30px;
          top:-2px;
        }
        .img-box{
          float: left;
          width: 210px;
          height: 290px;
          overflow: hidden;
          display: inline-block;
          overflow: hidden;
          position: relative;
          border-radius: 10px;
          background: -webkit-linear-gradient(to right, #ff643a,#f71f1f);
          background: linear-gradient(to right, #ff643a,#f71f1f);
          img{
            wdith:100%;
          }
          .btm-fix{
            font-sise:12px;
            color:#fff;
            line-height:34px;
            background-color: #dc9916;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            text-align: center;
          }
        }

        .r-box{
          margin-left: 20px;
          position: relative;
          min-height: 290px;
          max-width: 450px;
          float: left;
          display: inline-block;
          .tle-box{
            padding-top: 8px;
            span{
              font-size: 24px;
              color: #555555;
            }
            .red-f{
              color: #d1252f;
              .big-f{
                font-size: 36px;
                line-height: 36px;
              }
            }

          }
          .tle-btm{
            padding: 36px 0 0;
            color: #555555;
            font-size: 18px;
            line-height:32px;
            height: 132px;
            display: block;
            box-sizing: border-box;
            .y-f{
              color: #f86f1e;
            }
          }
          .price-box{
            width:-webkit-fit-content;
            width:fit-content;
            padding-left: 14px;margin-top: 16px;
            height: 50px;
            border-radius: 50px;
            border: 2px solid #ff0000;
            box-sizing: border-box;
            padding-right: 190px;
            position: relative;
            text-align: center;
            .price-num{
              color: #f82421;
              font-size: 20px;
              line-height: 48px;
              .zh-t{
                font-size: 16px;
                color: #555;
              }
              .big-f{
                font-size: 37px;
              }
              .old-price{
                color: #555;
                padding-left: 4px;
                text-decoration: line-through;
              }
            }
            .pay-btn{
              width: 179px;
              height: 50px;
              position: absolute;
              right: -2px;
              top: -2px;
              font-size: 24px;
              color: #fff;
              cursor: pointer;
              line-height: 50px;
              text-align: center;
              border-radius: 50px;
              background: -webkit-linear-gradient(to right, #ff643a,#f71f1f);
              background: linear-gradient(to right, #ff643a,#f71f1f);
              box-shadow: 0px 8px 10px rgba(255,138,118,0.39);

            }
          }
          .btm-btmtip{
            font-size: 14px;
            color: #555555;
            padding-top: 20px;
            white-space: nowrap;
          }
        }
        .btm-tip{
          font-size: 12px;
          color: #555;
          padding-top: 20px;
          display: block;
          float: left;
        }
        &:nth-child(1),&:nth-child(2){
          .img-box{
            .btm-fix{
              background-color:#e52624;
            }
          }
        }
        &:nth-child(3),&:nth-child(4),&:nth-child(5),&:nth-child(6){
          .price-box{
            position: absolute;
            bottom: 29px;
            left: 0;
          }
        }
        &:nth-child(3),&:nth-child(4),&:nth-child(5),&:nth-child(6){
           .r-box .price-box{
             border-color: #ffb33a;
             .pay-btn{
               background: linear-gradient(to right,#ffa10c,#f76b1f);
               box-shadow: 0px 9px 9px rgba(248,112,33,0.2);


             }
           }

        }
        // &:nth-child(6){
        //   .r-box{
        //     .tle-btm{
        //       height: 118px;
        //     }
        //   }
        // }
      }
    }
    .foot-text{
      font-size: 13px;
      color: #fff;text-align: center;
      line-height: 24px;
      padding-bottom: 40px;
    }
    .foot-tip{
      font-size: 15px;
      color: #fff;
      letter-spacing: 3px;
      text-align: center;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/activity/DoubelEleven3.vue